import axios from "axios";
import { API_BASE_URL, getAuthConfig } from "./apiClient";

const authGet = (path, config = {}) =>
  axios.get(`${API_BASE_URL}${path}`, { ...getAuthConfig(), ...config });

const authPost = (path, body, config = {}) =>
  axios.post(`${API_BASE_URL}${path}`, body, { ...getAuthConfig(), ...config });

const authPut = (path, body, config = {}) =>
  axios.put(`${API_BASE_URL}${path}`, body, { ...getAuthConfig(), ...config });

const authDelete = (path, config = {}) =>
  axios.delete(`${API_BASE_URL}${path}`, { ...getAuthConfig(), ...config });

// Employees
export const fetchEmployeeMe = async () => {
  const response = await authGet("/employees/me");
  return response.data;
};

// Leave
export const fetchLeaveBalance = async () => {
  const response = await authGet("/leave/balance");
  return response.data;
};

export const applyLeaveRequest = async (payload) => {
  const response = await authPost("/leave/requests", payload);
  return response.data;
};

export const fetchMyLeaveHistory = async (status) => {
  const response = await authGet("/leave/requests/me", {
    params: status ? { status } : undefined,
  });

  return response.data?.items || [];
};

export const fetchAllLeaveRequests = async (params = {}) => {
  const response = await authGet("/leave/requests", { params });
  return response.data?.items || [];
};

export const updateLeaveRequestStatus = async (requestId, status) => {
  const response = await authPut(`/leave/requests/${requestId}/status`, {
    status,
  });

  return response.data;
};

export const updateLeaveRequestType = async (requestId, leaveType) => {
  const response = await authPut(`/leave/requests/${requestId}/leave-type`, {
    leaveType,
  });

  return response.data;
};

export const updateLeaveBalanceAdmin = async (payload) => {
  const response = await authPut("/leave/balance", payload);
  return response.data;
};

// Attendance
export const fetchAttendancePunches = async (params = {}) => {
  const { fromDate, toDate, limit = 10 } = params;
  const safeLimit = Math.min(Math.max(Number(limit) || 10, 1), 100);
  const response = await authGet("/attendance/punches", {
    params: { fromDate, toDate, limit: safeLimit },
  });
  return response.data?.items || [];
};

export const fetchCalendarPunchesSafe = async (params = {}) => {
  try {
    return await fetchAttendancePunches({ ...params, limit: 100 });
  } catch {
    return [];
  }
};

export const fetchAttendanceByDate = async (date) => {
  const response = await authGet(`/attendance/punches/${date}`);
  return response.data;
};

export const fetchArBalance = async () => {
  const response = await authGet("/attendance/regularization/balance");
  return response.data;
};

export const submitArRequest = async (payload) => {
  const response = await authPost("/attendance/regularization", payload);
  return response.data;
};

export const fetchMyArRequests = async (status) => {
  const response = await authGet("/attendance/regularization/me", {
    params: status ? { status } : undefined,
  });

  return response.data?.items || [];
};

export const fetchAllArRequests = async (params = {}) => {
  const response = await authGet("/attendance/regularization", { params });
  return response.data?.items || [];
};

export const updateArRequestStatus = async (requestId, status) => {
  const response = await authPut(
    `/attendance/regularization/${requestId}/status`,
    { status },
  );

  return response.data;
};

// Dashboard
export const fetchDashboardSummary = async () => {
  const response = await authGet("/dashboard/summary");
  return response.data;
};

// Feed
export const fetchFeedPosts = async () => {
  const response = await authGet("/feed/posts");
  return response.data?.items || [];
};

export const createFeedPost = async (payload) => {
  const response = await authPost("/feed/posts", payload);
  return response.data;
};

export const markAttendance = async (payload) => {
  const response = await authPost("/attendance/mark", payload);
  return response.data;
};

// HR Handbook
export const fetchHandbookDocuments = async () => {
  const response = await authGet("/hr-handbook/documents");
  return response.data?.items || [];
};

export const uploadHandbookDocument = async (payload) => {
  const response = await authPost("/hr-handbook/documents/upload", payload);
  return response.data;
};

export const deleteHandbookDocument = async (documentId) => {
  await authDelete(`/hr-handbook/documents/${documentId}`);
};
